export default __webpack_public_path__ + "static/notification-9645dd5afc4a76f125be1943f96c0099.png";